import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import ExcelBulkEditProductDiscountModal from '../../../../views/product/common/modal/ExcelBulkEditProductDiscountModal';
import withModal from '../../../../lib/hoc/withModal';
import { productActions } from '../../../../store/modules/product';

class ExcelBulkEditProductDiscountModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
    };
  }

  /**
   *  상품 할인 변경하기
   */
  onSubmit = () => {
    const { excelBulkEditProductDiscount } = this.props;
    const { file } = this.state;

    if (!file) {
      message.error('업로드할 파일을 선택해 주세요.');
      return;
    }

    excelBulkEditProductDiscount({
      attachment: [file],
    });

    /**
     * 모달 닫기
     */
    this.closeModal();
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'excelBulkEditProductDiscount',
      value: false,
    });
  };

  /**
   * 엑셀 파일 변경시 callback
   */
  onChange = (file) => {
    this.setState({
      file,
    });
  };

  render() {
    const { isOpen } = this.props;
    const { file } = this.state;

    return (
      <ExcelBulkEditProductDiscountModal
        isOpen={isOpen}
        file={file}
        onSubmit={this.onSubmit}
        onChange={this.onChange}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.excelBulkEditProductDiscount.isOpen,
    data: state.product.excelBulkEditProductDiscount.data,
  };
};

const mapDispatchToProps = {
  excelBulkEditProductDiscount: productActions.excelBulkEditProductDiscount,
  toggleModal: productActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ExcelBulkEditProductDiscountModalContainer));
